import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'prettifyNotificationType' })
export class PrettifyNotificationTypePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
        case 'sms':
          return 'SMS';
        case 'voice':
          return 'Call';
        default:
          return 'Reply';
      }
  }
}
